import { render } from "./About.vue?vue&type=template&id=f31f37f8&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=f31f37f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f31f37f8"]])

export default __exports__